<template>
  <div class="leftBottom">
      <template v-for="(item,index) in list">
    <el-row style="display: flex;height: 50%;">
      <el-col :span="2" style="height: 100%;">
        <div class="left">
          <div class="circle" style="width: 30%; height: 10%; border: 4px solid rgb(255, 0, 0); border-radius: 50%;"></div>
          <div class="line" style=" width: 0px;align-items:stretch; height: 100%; border: 2px solid rgb(255, 0, 0);"></div>
        </div>
      </el-col>
      <el-col :span="15">
        <div class="middle" style="height: 100%;">
          <div class="info">
            <div class="time" :style="{fontSize:getTimeFontSize()}">
              {{item.time}}
            </div>
            <div class="context" :style="{paddingLeft:getPadding(),paddingRight:getPadding(),
            paddingTop:getPadding(),paddingBottom:getPadding()}"
            >
              <div class="title" :style="{fontSize:getTitleFontSize()}"
               style=" font-family: &quot;Microsoft YaHei&quot;; font-weight: 400; color: rgb(16, 221, 255);">
                {{item.name}}
              </div>
              <div class="dec" :style="{fontSize:getContentFontSize(),
              }"
              style="overflow: hidden;color:#fff; text-overflow: ellipsis; height: 100%;flex: 1;">
                {{item.desc}}
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="right">
          <div class="rightImg" style="width:100%;display: flex;align-items: center;height: 100%;">
            <span @click="leftClick(item,index)" class="leftButton"  v-if="checkShowBtn(item)"
            style=" width: 14px; height: 31px;background: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAgCAYAAAAbifjMAAAABHNCSVQICAgIfAhkiAAAAU5JREFUSEudlX9Vw1AMhXMdVEJRsDlgONhVwHAACsABEhgKAgrAAcXBcDAUhPN60p3t8X61/T/fyct3k0IWfKraA3gxswfMrVfVDsCHiKzN7H0J4BPAtZl9i8hmFkBV9wBuzew3dEDy0AxQ1XsAz168ITmE5zcBVHUXhhYKzOyO5H6aXRWgqmsfWhcXVztwXV8iEopfSe5ia9kOYl0ktynlJcAAYDXpInlsBkS6+lxxcgaq+gTgMdaVS+zFEyJdJPlWi/oJ4LrCxP+5LkFGQOQ6qSv7hFZdJcCk68cXJKmrBMjmvDbAk8bSstQg5xYWdVLKwcXaNgXJlY5J9DxUw5RcpmkXRORoZjfT9WleJu9kvH81SPEitXTSctKKnVQB/pzxX+DPuTq/D62ATkQCZCUigw92jHwTwLtIQpoBOcgsQAwJp342wCG9iIS/0/YPRjwCLhnZuacAAAAASUVORK5CYII=&quot;) 0% 0% / 100% 100%;"></span>
            <template v-for="(item2,index2) in item.fjList">
               <el-image  v-if="item2.fjType==='image'"  :src="item2.path" fit="fill"
                  alt="" style="width:75%;flex: 1; height: 60%;padding-left: 8px;padding-right: 8px;"
                  :preview-src-list="getImageList(item)",>
               </el-image>
                <video-hls v-else :chartConfig="getVideoChartConfig(item2)"
                width="75%" height="40%"
                style="flex: 1; padding-left: 8px;padding-right: 8px;"></video-hls>
            </template>

            <span class="rightButton" v-if="checkShowBtn(item)"
             @click="rightClick(item,index)" style=" width: 14px; height: 31px; background: url(&quot;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAgCAYAAAAbifjMAAAABHNCSVQICAgIfAhkiAAAAVRJREFUSEudleFVwkAQhHcqkA60A7ECsYNsBUIF2oF0oFZgqOBKkA6EDigBKxjf5m3yQLjcXvIrP7Jf9mZuZ5FSmgN4J6mqepTKBymlLYBHEdmRfKqFGGBmxQBuRaRtmmZV0wTsYzuGiFgnNyQ/VfU1CukADlkA+LZ3kitVbSOQAeCQJYAvh5ge2xLkDOCQDwAvInJ0UXdjkAuAQ1oAzyJyIPkw5kwOYM6YqPcle68CvIuQvVlA1N5RQMTeIqBkbwjgkDWAt//2hgE5e6sADrHBG+ydAjB7Dz54mymA7paS/BWRRRUgpdQLaRPbDVsYkFI6ndRh3EOAXLGJWgSMFRcBpeJRgMf9j6dTNidzeWC7wvJxRnKjqstcKl2LtHDxxRG87dCf+45OY73qz2cA204ATLA7knu7otEV1602F2xeW9xp0C/XKcU9wPbiWkSW0bZPLf0DiQT9KCWVMfIAAAAASUVORK5CYII=&quot;) 0% 0% / 100% 100%;"></span>
          </div>
        </div>
      </el-col>
    </el-row>
    </template>
  </div>
</template>

<script>
  import fwUtil from 'framework-util'
  import VideoHls from '../images/VideoHls.vue'
  import {getDataService} from '../../api/chart/chart/index.js'
  export default {
    // props: ["list", "imgList", "isShow", "col", "borderSty"],
    props: {
      chartConfig: {
        type: Object,
        default: function() {
          return {
            timeFontSize: 14,
            titleFontSize: 12,
            contentFontSize: 12
          };
        },
      },
     listData:{
       type:Array,
       default(){
         return []
       }
     },
     queryConfig:{
       type:Object,
       default(){
         return {
           url:null,
           params:[]
         }
       }
     },
      screen: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          };
        },
      },
      page: {
        type: Object,
        default () {
          return {
            height: 1920,
            width: 1280,
          };
        },
      },
    },
    data() {
      return {
        list:this.listData,
        timer:null,
        //   isShow:true
      };
    },
    components: {
      VideoHls
    },
    watch: {
      queryConfig:{
        handler(newValue, oldValue) {
          this.getData()
        },
        deep: true
      }
    },
    mounted() {
      this.getData()
       if(this.timer!=null){
         clearInterval(this.timer)
         this.timer=null
       }
       let that=this
       this.timer=setInterval(function(){
         that.getData()
       },1000*60*1)
    },
    beforeDestroy() {
      if(this.timer!=null){
        clearInterval(this.timer)
        this.timer=null
      }
    },
    computed: {},
    methods: {
      getImageList(item){
        let imageList=[]
        if(item.fjList){
          for(let i=0;i<item.fjList.length;i++){
            if(item.fjList[i].fjType==='image'){
              imageList.push(item.fjList[i].path);
            }
          }
        }
        return imageList;
      },
      checkShowBtn(item){
        if(item.fjList && item.fjList.length>0){
          return true
        }
        return false
      },
      leftClick(item,index){
        if(item.currentIndex<=0){
          return;
        }
        item.currentIndex--;
        //this.$set(item,"currentIndex",item.currentIndex)
        this.$set(this.list, index, item)
      },
      rightClick(item,index){
        if(item.currentIndex>=item.fjList.length-1){
          return;
        }
        item.currentIndex++;
        console.error(item.currentIndex)
        this.$set(this.list, index, item)
      },
      checkImage(item,item2,index2){
        if(item2.fjType==='image' && item.currentIndex==index2){
          return true
        }
        return false
      },
      checkVideo(item,item2,index2){
        if(item2.fjType==='video' && item.currentIndex==index2){
          return true
        }
        return false
      },

      getVideoChartConfig(item){
        let config={
          videoSrc:item.path,
          type:'video/mp4'
        }
        return config;
      },
      getData(){
        let that=this
        if(this.queryConfig && this.queryConfig.url){
          let url=this.queryConfig.url
          let params={}
          if(this.queryConfig.params){
            for(let i=0;i<this.queryConfig.params.length;i++){
              if(this.queryConfig.params[i].target
               && this.queryConfig.params[i].source){
                 let _value=fwUtil.Helper.GetQueryString(this.queryConfig.params[i].source)
                 if(_value){
                   params[this.queryConfig.params[i].target]=_value
                 }
               }
            }
          }
          getDataService(url,params).then((res)=>{
            that.list=res
            if(that.list && that.list.length>0){
              for(let i=0;i<that.list.length;i++){
                that.list[i].currentIndex=0
              }
            }
          })

        }
      },
      getTimeFontSize() {
        let _width = this.chartConfig.timeFontSize ? this.chartConfig.timeFontSize : 14;
        let width = (_width / this.page.width) * this.screen.width;

        if (width < 12) {
          width = 12
        }
        return width + "px";
      },

      getPadding(){
          let _width = this.chartConfig.padding ? this.chartConfig.padding : 12;
          let width = (_width / this.page.width) * this.screen.width;

          if (width < 12) {
            width = 12
          }
          return width + "px";
      },
      getTitleFontSize() {
        let _width = this.chartConfig.titleFontSize ? this.chartConfig.titleFontSize : 14;
        let width = (_width / this.page.width) * this.screen.width;

        if (width < 12) {
          width = 12
        }
        return width + "px";
      },
      getContentFontSize() {
        let _width = this.chartConfig.contentFontSize ? this.chartConfig.contentFontSize : 12;
        let width = (_width / this.page.width) * this.screen.width;

        if (width < 12) {
          width = 12
        }
        return width + "px";
      }
    }
  };
</script>

<style>
  .leftBottom {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .leftBottom .left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .leftBottom .time {
    margin-bottom: 5%;
    background: rgb(12, 162, 228);
    padding:0 10px;
    height: 15%;
    align-items: center;
    justify-content: center;
    display: inline-block;
    border-radius: 26px;
    font-family:     Microsoft YaHei;
    font-weight: 400;
    color: rgb(255, 255, 255);
  }

  .leftBottom .middle {
    display: flex;
    align-items: center;
    justify-content: left;
    height: 100%;
    margin-left: 2%;
  }

  .leftBottom .middle .info {
    width: 100%;
    height: 100%;
  }

  .leftBottom .right {
    display: flex;
    align-items: center;
    justify-content: left;
    height: 100%;
    width: 100%;
  }

  .leftBottom .context {
    display: flex;
    flex-direction: column;
    margin-left: 5px;
     width: 90%;
     height: 50%;
    background-size: auto 100%;
    background: url(data:image/png;base64,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) 0% 0% / 100% 100%;
  }

  .leftBottom::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
    -ms-overflow-style: none;
    /* IE 10+ */
    scrollbar-width: none;
    /* Firefox */
  }
</style>



// WEBPACK FOOTER //
// src/components/process/timeline.vue